/* Northsheep — "Add a filling" (snippets/ns-filling-option.liquid; loaded on every page by layout/theme.liquid while a
   filling product is set, with window.NsFilling = {product, variant, cushions}).

   Ticked, Add to basket puts the cushions AND one filling per cushion in the basket in one request (owner, 29 Sep
   2026: "on the product page give the option 'add filling' and then the filling product gets added"). Dawn's own
   form can only add one product, so the submit is taken over in the capture phase, the same way the "Buy more,
   save more" sets do it (assets/ns-bundle-tiers.js). With a set chosen, the set script adds the pieces and asks
   window.__nsCartExtras for extra lines: this file answers with one filling per piece.

   ONE FILLING PER CUSHION, KEPT THAT WAY ("they also can not order filling lose. same like the brush"). A cushion
   capped at its stock gets exactly as many fillings as went in, and whenever a cushion leaves the basket its
   filling leaves with it. snippets/ns-filling-check.liquid is the net under it: more fillings than cushions keeps
   Checkout off.

   THE DRAWER'S is-empty CLASS IS OURS TO SET. renderContents redraws the inside of the drawer but not the class on
   the <cart-drawer> element itself, and that class decides whether the rows or the "your basket is empty" screen
   may show (component-cart-drawer.css). Dawn's form and basket rows set it themselves; a bare fetch has to as well.
   Left stale, a first add to an empty basket opened without its header, and a basket emptied by the trim below
   showed nothing at all (owner, 29 Sep 2026: "the cart crashed", "the card goes blank").

   Registered once, on document: a colour swap re-renders <main> and re-runs this file. */
(function () {
  if (window.__nsFilling) return;
  window.__nsFilling = true;
  var CFG = window.NsFilling || {};
  var CUSHIONS = {};
  (CFG.cushions || []).forEach(function (id) {
    CUSHIONS[String(id)] = true;
  });

  function boxFor(form) {
    var fid = form && form.getAttribute ? form.getAttribute('id') : '';
    return fid ? document.querySelector('[data-ns-filling][data-form="' + fid + '"]') : null;
  }

  function ticked(box) {
    var c = box && box.querySelector('.ns-fill__check');
    return !!(c && c.checked);
  }

  /* One filling per piece, for the set script. */
  window.__nsCartExtras = window.__nsCartExtras || [];
  window.__nsCartExtras.push(function (form, count) {
    var box = boxFor(form);
    if (!ticked(box) || !count) return [];
    return [{ id: Number(box.dataset.variant), quantity: count }];
  });

  /* A set with a colour per piece is chosen for this form: its script adds the pieces (and our fillings). A set
     of a one-colour product has no colour rows; Dawn would add it as a plain quantity, so we do it here. */
  function setHandlesIt(form) {
    var b = document.querySelector('[data-ns-bundle][data-form="' + form.getAttribute('id') + '"]');
    if (!b) return false;
    var r = b.querySelector('.ns-bundle__radio:checked');
    var n = r ? parseInt(r.value, 10) || 1 : 1;
    return n > 1 && b.querySelectorAll('.ns-bundle__piece').length > 0;
  }

  function url(key, fallback) {
    return ((window.routes && routes[key]) || fallback) + '.js';
  }

  function json(r) {
    return r.json();
  }

  function getCart() {
    return fetch(url('cart_url', '/cart'), { headers: { Accept: 'application/json' } }).then(json);
  }

  function isFilling(it) {
    return String(it.product_id) === String(CFG.product);
  }

  function isCushion(it) {
    return !!CUSHIONS[String(it.product_id)];
  }

  function ofVariant(id) {
    return function (it) {
      return String(it.variant_id) === String(id);
    };
  }

  function count(cart, test) {
    var n = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (test(it)) n += it.quantity;
    });
    return n;
  }

  function sectionsToRender() {
    var drawer = document.querySelector('cart-drawer');
    if (document.getElementById('main-cart-items')) return ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
    if (drawer && drawer.getSectionsToRender) {
      return drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function change(variant, quantity) {
    return fetch(url('cart_change_url', '/cart/change'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: String(variant),
        quantity: quantity,
        sections: sectionsToRender().join(','),
        sections_url: window.location.pathname,
      }),
    }).then(json);
  }

  /* The drawer as it stands, without changing the basket (Section Rendering API). */
  function currentSections() {
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionsToRender().join(',')), {
      headers: { Accept: 'application/json' },
    })
      .then(json)
      .then(function (s) {
        return { sections: s };
      });
  }

  /* CartDrawer.renderContents without the open() at the end: a trim while the drawer is shut must not pop it open. */
  function renderQuietly(drawer, resp) {
    drawer.getSectionsToRender().forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      var html = resp.sections && resp.sections[s.id];
      if (el && html) el.innerHTML = drawer.getSectionInnerHTML(html, s.selector);
    });
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  /* Draw an answer that carries `sections`; the cart page simply reloads. how: 'add' = what Add to basket does
     (window.nsBasketOpen decides between the drawer and the small note, as for any add), 'open' = show the drawer,
     anything else = redraw it, open or shut as it is. Resolves once everything listening to the basket has
     redrawn too (Dawn's drawer rows fetch themselves again on cartUpdate). */
  function render(resp, source, how) {
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
      return Promise.resolve();
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      if (how === 'add' && window.nsBasketOpen) window.nsBasketOpen.render(drawer, resp);
      else if (how === 'open' || drawer.classList.contains('active')) drawer.renderContents(resp);
      else renderQuietly(drawer, resp);
      drawer.classList.toggle('is-empty', !!drawer.querySelector('.drawer__inner-empty'));
    }
    /* A bare fetch fires none of Dawn's cart events; the free gift and the basket rows listen for this. No
       cartData: an add answers with the added lines, not the basket. */
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      return Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: source })).catch(function () {});
    }
    return Promise.resolve();
  }

  /* The fillings on their way out go from the drawer at once, with the cushion that was just taken out, and so
     does the "fillings on their own" line under the total, which is about to stop being true. The redraw that
     follows makes it real; if the request fails, the next basket event brings them back. */
  function hideFillings() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var q = drawer.querySelectorAll('[data-quantity-variant-id="' + CFG.variant + '"]');
    for (var i = 0; i < q.length; i++) {
      var row = q[i].closest('.cart-item');
      if (row) row.style.display = 'none';
    }
    var note = drawer.querySelectorAll('[data-ns-filling-only]');
    for (var j = 0; j < note.length; j++) note[j].style.display = 'none';
  }

  /* Never more fillings than cushions. `cart` = the basket when the caller already has it (a basket row change
     hands it over); otherwise it is read. */
  var busy = false;
  var again = false;
  function balance(cart) {
    if (!CFG.product || !CFG.variant) return Promise.resolve();
    if (busy) {
      again = true;
      return Promise.resolve();
    }
    busy = true;
    return (cart && cart.items ? Promise.resolve(cart) : getCart())
      .then(function (c) {
        var fill = count(c, isFilling);
        var cush = count(c, isCushion);
        if (fill <= cush) return null;
        if (!cush) hideFillings();
        return change(CFG.variant, cush).then(function (resp) {
          if (resp && !resp.status && resp.sections) return render(resp, 'ns-filling-balance');
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) {
          again = false;
          return balance();
        }
      });
  }

  /* A cushion changed or left the basket (drawer or cart page). Our own writes carry 'ns-filling*' sources. A
     basket row change hands over the whole basket, so it is acted on at once and the fillings leave WITH their
     cushion, not a moment later. Anything else (an add answers with its own lines only) reads the basket. */
  var timer = null;
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (evt && typeof evt.source === 'string' && evt.source.indexOf('ns-filling') === 0) return;
      clearTimeout(timer);
      var cd = evt && evt.source === 'cart-items' ? evt.cartData : null;
      if (cd && cd.items && typeof cd.item_count === 'number') {
        balance(cd);
        return;
      }
      timer = setTimeout(balance, 250);
    });
  }
  /* The basket page on arrival: a basket from an earlier visit may carry a filling too many. */
  if (document.getElementById('main-cart-items')) balance();

  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      var box = boxFor(f);
      if (!box || !ticked(box) || setHandlesIt(f)) return;
      var idInput = f.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      var qtyEl = document.getElementById('Quantity-' + box.dataset.section);
      var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      e.preventDefault();
      e.stopImmediatePropagation();
      /* Still adding (add() marks the button busy): a second tap is not a
         second cushion and filling. Dawn's own aria-disabled guard never runs
         for a submit taken here (audit 2 Oct 2026: a double tap added twice). */
      var busyBtn = f.querySelector('[type="submit"]');
      if (busyBtn && busyBtn.getAttribute('aria-disabled') === 'true') return;
      add(box, f, idInput.value, qty);
    },
    true
  );

  /* Shopify's own words for a capped add ("Only 1 item was added to your cart due to availability.", in the
     store's language) on the cushion's row in the drawer, in Dawn's slot for a row's stock message. */
  function rowNote(variant, msg) {
    var drawer = document.querySelector('cart-drawer');
    var q = msg && drawer && drawer.querySelector('[data-quantity-variant-id="' + variant + '"]');
    var row = q && q.closest('.cart-item');
    var slot = row && row.querySelector('.cart-item__error-text');
    if (slot) slot.textContent = msg;
  }

  /* What a plain Add to basket hands the drawer: the added line, with the sections. The small "Added to your
     basket" note (assets/ns-basket-open.js) shows that line's photo: the cushion's, not the filling's. */
  function asAdded(resp, variant) {
    var line = (resp.items || []).filter(ofVariant(variant))[0];
    if (!line) return resp;
    var out = {};
    for (var k in line) out[k] = line[k];
    out.sections = resp.sections;
    return out;
  }

  function add(box, form, cushion, qty) {
    var fillVariant = box.dataset.variant;
    var btn = form.querySelector('[type="submit"]');
    var spin = btn && btn.querySelector('.loading__spinner');
    var err = box.querySelector('[data-ns-filling-error]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
    if (btn) {
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
    }
    if (spin) spin.classList.remove('hidden');
    var done = function () {
      if (btn) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      }
      if (spin) spin.classList.add('hidden');
    };
    /* The basket before the add: when Shopify stops at the stock, this is how we know how many went in. */
    var before = null;
    getCart()
      .then(function (c) {
        before = c;
      })
      .catch(function () {
        /* no snapshot: the count below falls back to "never more fillings than cushions" */
      })
      .then(function () {
        return fetch(url('cart_add_url', '/cart/add'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          /* Shopify lists the last line of a request first: the filling goes first so the basket shows the
             cushion with its filling under it. */
          body: JSON.stringify({
            items: [
              { id: Number(fillVariant), quantity: qty },
              { id: Number(cushion), quantity: qty },
            ],
            sections: sectionsToRender().join(','),
            sections_url: window.location.pathname,
          }),
        });
      })
      .then(json)
      .then(function (resp) {
        if (!resp.status) {
          done();
          return render(asAdded(resp, cushion), 'ns-filling', 'add').then(function () {
            return balance();
          });
        }
        /* Shopify added what the stock allowed, or nothing, and every filling anyway (they are not stocked). Keep
           one filling per cushion that went in, show the basket, and say why: on the cushion's row, and here for
           when the drawer is closed. */
        var msg = resp.description || resp.message || '';
        if (err && msg) {
          err.textContent = msg;
          err.hidden = false;
        }
        return getCart()
          .then(function (after) {
            var fillNow = count(after, isFilling);
            var want = fillNow;
            if (before) {
              var went = Math.max(0, count(after, ofVariant(cushion)) - count(before, ofVariant(cushion)));
              want = count(before, isFilling) + went;
            }
            want = Math.min(want, count(after, isCushion));
            return want !== fillNow ? change(fillVariant, want) : currentSections();
          })
          .then(function (drawn) {
            done();
            if (!drawn || drawn.status || !drawn.sections) return null;
            return render(drawn, 'ns-filling', 'open').then(function () {
              rowNote(cushion, msg);
            });
          });
      })
      .catch(done);
  }
})();
